import { getApiKey } from "../../utils/apiKey";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import React, { useEffect, useState } from "react";
import { apiCall_domain, apiCall_domainV2 } from "../api";
import CategoriesList from "../Categories/CategoriesList";
import {
  Box,
  FormControl,
  MenuItem,
  Pagination,
  Select,
  Switch,
} from "@mui/material";
import CarFiltering from "../Categories/carFiltering";
import ProductMainCard from "../global/ProductMainCard";
import { createGlobalStyle } from "styled-components";
import Header from "../header";

const PopularCars = (props) => {
  const [selectedSort, setSelectedSort] = useState();
  const [original, setOriginal] = useState(false);
  const [paginationData, setPaginationData] = useState(1);
  const [defaultPriceRange, setDefaultPriceRange] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filters, setFilters] = useState();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [features, setFeatures] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(true);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [priceSort, setPriceSort] = useState([
    { label: "هیچکدام", value: 6 },
    { label: "ارزان ترین", value: 2 },
    { label: "گران ترین", value: 1 },
    { label: "جدید ترین", value: 4 },
    { label: "پر فروش ترین", value: 5 },
    { label: "پر بازدید ترین", value: 3 },
  ]);
  const [brands, setBrands] = useState("");
  const [models, setModels] = useState("");
  const [types, setType] = useState("");
  const [cars, setCars] = useState("");

  useEffect(() => {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domain}/customer/car-types`, { headers: headers })
      .then((res) => setCars(res.data.data));
  }, []);

  const handleCarBrand = (e) => {
    setBrands(e.target.value);
    setModels("");
    setType("");
  };
  const handleCarModel = (e) => {
    setModels(e.target.value);
    setType("");
  };
  const handleCarType = (e) => {
    setType(e.target.value);
  };
  const [appliedFilters, setAppliedFilters] = useState({});
  const [car, setCar] = useState([]);
  const Headers = {
    Authorization: getApiKey(),
    "content-type": "application/json",
  };
  const [showDetail, setShowDetail] = useState(false);
  const defaultData = {
    page: 1,
    price_from: 0,
    price_to: 999999999,
    orderBy: 6,
    stock: 0,
    car_type_id: +props.match.params.carId,
    car_brand_id: +props.match.params.carBrandId,
    just_fabric: false,
  };
  useEffect(() => {
    const getCategories = axios.get(`${apiCall_domain}/customer/categories`, {
      headers: Headers,
    });
    const getAllProducts = axios.post(
      `${apiCall_domain}/customer/categories/${
        props.match.params.subCategoryId
          ? props.match.params.subCategoryId
          : props.match.params.categoryId
      }/products?page=1`,
      defaultData,
      { headers: Headers },
    );

    const getAllCars = axios.get(`${apiCall_domainV2}/customer/popular_cars`, {
      headers: Headers,
    });

    axios.all([getCategories, getAllProducts, getAllCars]).then(
      axios.spread((...res) => {
        const categories = res[0];
        setCategories(categories.data.data);
        const products = res[1];
        setPaginationData(products.data.products.meta);
        setProducts(products.data.products.data);
        setAppliedFilters({
          price_from: products.data.options.price_range.min,
          price_to: products.data.options.price_range.max,
        });
        setFilters(products.data.options.filters);
        setDefaultPriceRange([
          products.data.options.price_range.min,
          products.data.options.price_range.max,
        ]);
        const cars = res[2];
        setCar(
          cars.data.data.find((car) => car.id === +props.match.params.carId),
        );

        setLoading(false);
        setCategoryLoading(false);
      }),
    );
  }, []);
  const getProducts = (page, isGet) => {
    setCategoryLoading(true);
    const getData = {
      features: features,
      page: page,
      stock: appliedFilters.stock ? 1 : 0,
      is_limited: appliedFilters.is_limited ? appliedFilters.is_limited : 0,
      price_from: appliedFilters.price_from,
      price_to: appliedFilters.price_to,
      orderBy: selectedSort ? selectedSort.value : 6,
      car_type_id: +props.match.params.carId,
      car_brand_id: +props.match.params.carBrandId,
      ...(original && { just_fabric: true }),
    };
    axios
      .post(
        `${apiCall_domain}/customer/categories/${
          props.match.params.subCategoryId
            ? parseInt(props.match.params.subCategoryId)
            : parseInt(props.match.params.categoryId)
        }/products?page=1`,
        isGet ? getData : defaultData,
        { headers: Headers },
      )
      .then((res) => {
        setAppliedFilters({
          stock: 0,
          price_from: res.data.options.price_range.min,
          price_to: res.data.options.price_range.max,
          orderBy: selectedSort?.value,
        });
        setProducts(res.data.products.data);
        setCategoryLoading(false);
        setFilters(res.data.options.filters);
        setPaginationData(res.data.products.meta);
        setDefaultPriceRange([
          res.data.options.price_range.min,
          res.data.options.price_range.max,
        ]);
      });
    if (!isGet) {
      setSelectedSort();
    }
  };

  useEffect(() => {
    getProducts(1, false);
  }, [props.match.params.subCategoryId, props.match.params.categoryId]);

  useEffect(() => {
    if (selectedSort) {
      getProducts(1, true);
    }
  }, [selectedSort]);
  useEffect(() => {
    getProducts(1, true);
  }, [original]);
  const handleStock = (e, newValue) => {
    setAppliedFilters({
      ...appliedFilters,
      stock: newValue,
    });
  };

  const changePriceRange = (e, newValue) => {
    setAppliedFilters({
      ...appliedFilters,
      price_from: newValue[0],
      price_to: newValue[1],
    });
  };

  const handleModal = () => {
    setShowFilterModal(!showFilterModal);
    if (showFilterModal) {
      setAppliedFilters({
        price_from: defaultPriceRange[0],
        price_to: defaultPriceRange[1],
      });
    }
    window.scrollTo(0, 0);
  };

  const handleOrderBy = (e) => {
    setSelectedSort(e.target.value);
  };

  const applyFilter = () => {
    getProducts(1, true);
    handleModal();
    window.scrollTo(0, 0);
  };

  const clearFilter = () => {
    setFeatures([]);
    getProducts(1, false);
    setAppliedFilters({
      price_from: defaultPriceRange[0],
      price_to: defaultPriceRange[1],
    });
    setShowFilterModal(false);
    window.scrollTo(0, 0);
  };

  const addFilter = (id, value) => {
    let state = [...features];
    const selectedFeature = state.find((feature) => +feature.id === id);
    const selectedFeatureDelete = state.findIndex(
      (feature) => +feature.id === id,
    );
    if (selectedFeature && value === "") {
      state.splice(selectedFeatureDelete, 1);
    } else if (selectedFeature) {
      selectedFeature.value = value;
      state[selectedFeatureDelete] = selectedFeature;
    } else if (value !== "") {
      state.push({ id, value });
    }

    setFeatures(state);
  };
  const checkForNumric = (id, value) => {
    const numRegex = /^[1-9][\.\d]*(,\d+)?$/;
    if (numRegex.test(value)) {
      addFilter(id, value);
    }
  };

  const checkForText = (id, value) => {
    addFilter(id, value);
  };

  const handlePagination = (event, page) => {
    getProducts(page, true);
  };
  const showDetails = () => {
    setShowDetail(!showDetail);
  };
  const GlobalStyles = createGlobalStyle`body{
      background: ${!showFilterModal ? "#E5E5E5" : "#fff"};
    }`;
  const currentCategory = categories.find(
    (category) => category.id == props.match.params.categoryId,
  );
  const originalToggler = () => {
    setOriginal(!original);
  };
  return loading ? (
    <Spinner />
  ) : (
    <>
      <GlobalStyles />
      {showFilterModal ? null : (
        <Header
          showSearchBar={true}
          showBasket={true}
          title={currentCategory?.name}
          showSearchBar={true}
        />
      )}
      <div className="populerCarCategory">
        <div className="populerCarCategoryTop">
          <div>
            <img src={car.image} alt="car" />
          </div>
          <div>
            <button>بررسی تخصصی</button>
          </div>
        </div>
        <div
          className={`populerCarCategoryText ${
            showDetail ? "showDetail" : null
          }`}
          onClick={showDetails}
        >
          <div className="headCategoryText">
            <span>{car.text}</span> <i className={"icon-chevron-down"} />
          </div>
        </div>
      </div>
      <div className="category">
        <CategoriesList
          itPopulerCars={true}
          car_type_id={+props.match.params.carId}
          car_brand_id={+props.match.params.carBrandId}
          categories={categories}
          selectedCategory={parseInt(props.match.params.categoryId)}
          selectedSubCategory={parseInt(props.match.params.subCategoryId)}
        />
        {categoryLoading ? (
          <Spinner />
        ) : (
          <>
            <div className="categoryFilter">
              <div className="filterBox">
                <i className="icon-filters" />
                <span
                  onClick={() => {
                    handleModal();
                  }}
                >
                  فیلتر بندی
                </span>
                <div
                  className={`carFilterModal ${
                    showFilterModal ? "showFilterModal" : null
                  }`}
                >
                  <CarFiltering
                    addFilter={addFilter}
                    checkForText={checkForText}
                    checkForNumric={checkForNumric}
                    handleModal={handleModal}
                    filter={filters}
                    price={[appliedFilters.price_from, appliedFilters.price_to]}
                    changePriceRange={changePriceRange}
                    handleStock={handleStock}
                    stock={appliedFilters.stock}
                    applyFilter={applyFilter}
                    clearFilter={clearFilter}
                    features={features}
                    defaultPrice={defaultPriceRange}
                    brands={brands}
                    models={models}
                    types={types}
                    cars={[]}
                    handleCarType={handleCarType}
                    handleCarModel={handleCarModel}
                    handleCarBrand={handleCarBrand}
                  />
                </div>
              </div>
              <div className="priceBox">
                <i className="icon-order" />

                <Box>
                  <FormControl>
                    <Select
                      onChange={handleOrderBy}
                      displayEmpty
                      value={selectedSort}
                    >
                      <MenuItem disabled> مرتب سازی</MenuItem>
                      {priceSort.map((range, index) => (
                        <MenuItem value={range} key={index}>
                          {range.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </div>
            </div>
            <div className="originalProducts ">
              <div className="originalSwitch">
                <label> نمایش محصولات فابریک</label>
                <Switch
                  value="fabric"
                  onClick={originalToggler}
                  className="originalSwitchFilter"
                  checked={original}
                />
              </div>
            </div>
            <p className="originalProductsCar">
              محصولات فابریک ماشین {car.car_name}
            </p>
            <div
              className={` categoryProductSection ${
                products.length ? " " : "noStockCategory"
              }`}
            >
              {!showFilterModal ? (
                products.length ? (
                  products.map((item, index) => (
                    <ProductMainCard
                      data={item}
                      deadline={item.deadline}
                      countDown={false}
                      featuresStat={true}
                      features={item.features}
                      key={index}
                    />
                  ))
                ) : (
                  <div className="noProductSection">
                    <span className="noStock">هیج کالایی وجود ندارد</span>
                  </div>
                )
              ) : null}
            </div>
            {paginationData.last_page > 1 ? (
              <div className="pagination">
                <Pagination
                  count={paginationData.last_page}
                  onChange={handlePagination}
                  page={paginationData.current_page}
                />
              </div>
            ) : null}
          </>
        )}
      </div>
    </>
  );
};

export default PopularCars;
